export default __webpack_public_path__ + "static/media/12.66ddbe29.jpg";